import $ from 'jquery';
import { tns } from 'tiny-slider/src/tiny-slider';
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin.js";
gsap.registerPlugin(DrawSVGPlugin);
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollToPlugin);
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import { SplitText } from "gsap/SplitText.js";

import {ionRangeSlider} from 'ion-rangeslider';
import SnazzyInfoWindow from 'snazzy-info-window/dist/snazzy-info-window.js';

window.jQuery = $;

require('@fancyapps/fancybox');
//import barba from '@barba/core';





const scrollTo = {
    class : '.scrollTo',
    init : function(){
        let $btn = $('.scrollTo');

        if($btn.length){
            $btn.click(function(e){
                e.preventDefault();
                let target = $(this).data('target');
                let $target = $(target);
                if($target.length){
                    gsap.to(window,{scrollTo:$target.offset().top - 70 });
                }else{
                    gsap.to(window,{scrollTo:0});
                }
            })
        }

    }
};

function has_filter($obj){

    let url = window.location.href;
    url = url.split('?');

    if(typeof url[1] !== 'undefined') {
        if (url[1].length !== 0) {
            gsap.to(window,{scrollTo:$obj.offset().top - 150 });
        }
    }
}
function initBrokers(){
    const $bt = $('.brokers-control button');
    const $brokers = $('.hidden-broker');

    const tl = gsap.timeline({paused:true,  ease: "power2.out"});

    if($brokers.length){
        $.each($brokers, function(index){
            if(index === 0) {
                tl.to(this, {duration: 0.7, autoAlpha: 1});
            }else{
                tl.to(this, {duration: 0.7, autoAlpha: 1}, '-=0.4');
            }
        })
    }

    $bt.click(function(e){
        e.preventDefault();
        let $this = $(this);

        if($(window).width() < 600){
            window.location = $this.data('url');
        }


        if($this.hasClass('backward')){
            tl.reverse();
            $this.removeClass('backward');
        }else{
            tl.play();
            $this.addClass('backward');
        }
    })

}
function formFields() {
   const $input = $('.floating-label');
   const $form = $('form.form');


   function updateText(event){
       let $this = $(this);
       let val = $this.val();

       $this.parent().removeClass('has-error').find('.error').html('');
       if (val != "") {
           $this.parent().addClass("float-label--active ");
       }
       else {
           $this.parent().removeClass("float-label--active ");
       }
   }

    $input.keydown(updateText);
    $input.change(updateText);

    $form.submit(function(e){
        e.preventDefault();
        let $this = $(this);
        let $bt = $this.find('button');
        $bt[0].disabled = true;

        let $errormsg = $this.parent().find('.error-msg');
        let $errorsuccess = $this.parent().find('.succes-msg');


        let $errors = $('.error');
        $errors.html('').parent().removeClass('has-error');
        $.ajax({
            url:$this.attr('action'),
            data: $this.serialize(),
            type: 'POST'
        }).done(function( data ) {

            if(data.status === 0){
                $.each(data.errors, function(){
                    let error = this;
                    $('#error-'+error[1]).html(error[0]).parent().addClass('has-error');
                    //$('#error-'+error[1]).html(error[0]);
                    $errormsg.fadeIn();
                    $bt[0].disabled = false;
                })
            }else{
                if($(window).width() < 900){
                    gsap.to(window,{scrollTo:$('.footer-form--wrap').offset().top - 90 });
                }
                $this.hide();
                $errormsg.hide();
                $errorsuccess.fadeIn();

            }
        });
    });

    $('.form [type="checkbox"]').change(function(){
        $(this).parent().removeClass('has-error').find('.error').html('');
    });

    $('.btn-submit').click(function(e){
        e.preventDefault();
        $form.submit();
    })
}
const slides = {
    class : '.section-main--sliders',
    slideTime: 4000,
    instance: [],
    init: function(){
        let obj = this;
        let $slides = $(obj.class);
        if($slides.length){
            let title = new SplitText(".section-main--sliders .section-main--slide .section-main--slideContent h1 .anim", {type:"words,chars", charsClass:"s-chr"});

            window.slider = tns({
                container: obj.class,
                items: 1,
                controlsContainer: '.section-main--controlsRight',
                slideBy: 'page',
                autoplay: true,
                autoplayTimeout: obj.slideTime,
                autoplayButton: false,
                autoplayButtonOutput: false,
                mode: 'gallery',
                animateIn: 'sliderFadeIn',
                animateOut: 'sliderFadeOut'
            });

            let clock = [];
            for(let i = 0; i < slider.getInfo().slideCount; i++){
                let tl = gsap.timeline({paused: true});
                let btn = $('.section-main--menu button[data-index="'+i+'"] .svg-button');
                tl.fromTo(btn.find('.svg-circle'), {drawSVG: '0%'}, {duration: 1, drawSVG:'100%', ease:'none'});
                tl.fromTo(btn.find('.svg-arrow'), {rotate: 0, transformOrigin:"1.44px -40.77px"}, {duration: 1, rotate: 360, ease:'none'}, '<');
                clock.push(tl);
            }

            let $menuBtn = $('.section-main--menu button');
            $menuBtn.click(function(){
                $menuBtn.removeClass('active');
                let $this = $(this);
                $this.addClass('active');
                slider.goTo($this.data('index'));
            });

            slider.events.on('transitionStart', function(info, eventName){
                slider.pause();
                let indexCurrent = info.index;
                $menuBtn.removeClass('active');
                $('.section-main--menu button[data-index="'+(info.displayIndex-1)+'"]').addClass('active');
                if($(window).width() > 7000) {
                    //$('.hollow-btn[data-slide]').fadeOut().removeClass('active');
                    $('.hollow-btn[data-slide]').fadeOut().removeClass('active');
                    $('.hollow-btn[data-slide=' + (info.displayIndex - 1) + ']').fadeIn(function () {
                        $(this).addClass('active');
                    });
                }else{
                    $('.hollow-btn[data-slide]').removeClass('active');

                    $('.hollow-btn[data-slide=' + (info.displayIndex - 1) + ']').addClass('active');
                }
                //console.log('=> ',$('.section-main--sliders .tns-slide-active').attr('class'));
            });

            slider.events.on('transitionEnd', function(info, eventName){
                let animTime = obj.slideTime / 1000;
                slider.play();
                clock[(info.displayIndex - 1)].tweenFromTo(0,1,{duration:animTime});
                //console.log('<= ',$('.section-main--sliders .tns-slide-active').attr('class'));
                //gsap.fromTo(".section-main--sliders .tns-slide-active .section-main--slideContent h1 .anim .s-chr", {opacity:0, /* scale: 0.2, */ x:-10, rotationZ:5}, {duration:1, opacity:1, /* scale:1, */ x:-0.1, rotationZ:5,  stagger:{each:0.05}, ease:"power4.out"});
                gsap.fromTo(".section-main--sliders .tns-slide-active .section-main--slideContent h1 .anim .s-chr", {opacity:0, scale:0.2}, {duration:0.6, opacity:1, scale:1, transformOrigin:"left top", force3D:true, stagger:{each:0.03}, ease:"power2.out"});
            });

            clock[0].tweenFromTo(0,1,{duration:obj.slideTime / 1000});
            gsap.fromTo(".section-main--sliders .tns-slide-active .section-main--slideContent h1 .anim .s-chr", {opacity:0, scale:0.2}, {duration:0.6, opacity:1, scale:1, transformOrigin:"left top", force3D:true, stagger:{each:0.03}, ease:"power2.out", delay: 0.5});

            obj.instance.push(slider);
        }
    }
};
/*
function initMap(){
    const $buttons = $('.section-map--controls button');
    const $navCont = $('.map-buttons');

    const mapStyle = [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e8ded7"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#d9ccc3"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#92c7bf"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#d0ddf2"
                },
                {
                    "lightness": 17
                }
            ]
        }
    ];
    const $map = $('#map');

    if($map.length > 0) {

        const map_markers = mapData;

        if(typeof mapMain === 'undefined'){
            return false;
        }

        let main_cords = mapMain.split(',');

        const map =  new google.maps.Map($map[0], {
            center: new google.maps.LatLng(main_cords[0], main_cords[1]),
            zoom: 12,
            panControl: false,
            zoomControl: true,
            mapTypeControl: false,
            overviewMapControl: false,
            scaleControl: false,
            streetViewControl: false,
            scrollwheel: false,
            fullscreenControl: false,
            gestureHandling: 'cooperative',
            styles: mapStyle,
        });

        const gmap_marker = [];

        let prev_infowindow =false;

        let bounds = new google.maps.LatLngBounds();

        let main = new google.maps.Marker({
            position: new  google.maps.LatLng(main_cords[0], main_cords[1]),
            title: map_markers.main_marker_title,
            map: map,
            icon: {
                url: 'assets/svg/pin.svg',
                size: new google.maps.Size(147, 82),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(108, 82)
            },
            visible: true,
            zIndex: 100,
            main: true
        });

        google.maps.event.addListener(main, 'click', function () {
            if (prev_infowindow && typeof prev_infowindow !== 'undefined') {
                prev_infowindow.close();
            }
        });

        bounds.extend(main.position);

        $.each(map_markers, function (i, marker) {

            let icon = {
                url: 'assets/svg/point.svg',
                size: new google.maps.Size(43, 43),
                anchor: new google.maps.Point(21, 21),
                origin: new google.maps.Point(0, 0),
            };
            gmap_marker[i] = new google.maps.Marker({
                position: new google.maps.LatLng(marker.lat, marker.lng),
                title: marker.title,
                map: map,
                icon: icon,
                visible: true,
                zIndex: 70,
                main: false,
                type : marker.category
            });


            bounds.extend(gmap_marker[i].position);

            let walk = '';
            let car = '';
            //  let short = 'map-infowindow--short';
            if(marker.walk.length){
                //short = '';
                walk = '<div class="map-time"><div class="ico-walk"></div>' + marker.walk + '</div>'
            }
            if(marker.car.length){
                // short = '';
                car = '<div class="map-time"><div class="ico-car"></div>' + marker.car + '</div>'
            }
            let map_content = '<div class="map-infowindow " style="text-align: center">' +
                '<div class="map-title">' + marker.title + '</div>' + walk + car+ '</div>';

            let infowindow = new google.maps.InfoWindow({
                content: map_content
            });

            google.maps.event.addListener(map, 'click', function () {
                if (prev_infowindow && typeof prev_infowindow !== 'undefined') {
                    prev_infowindow.close();
                }
            });

            google.maps.event.addListener(gmap_marker[i], 'click', function () {
                if (prev_infowindow && typeof prev_infowindow !== 'undefined') {
                    prev_infowindow.close();
                }
                prev_infowindow = infowindow;

                if(! gmap_marker[i].main) {
                    infowindow.open(map, gmap_marker[i]);
                }
            });


        });

        map.fitBounds(bounds);

        $buttons.click(function(e){
            let $this = $(this);
            let target = $this.data('cat');

            bounds = new google.maps.LatLngBounds();
            bounds.extend(main.position);

            if(prev_infowindow && typeof prev_infowindow !== 'undefined') {
                prev_infowindow.close();
            }

            if($this.hasClass('is-active')){
                $this.removeClass('is-active');
                $.each(gmap_marker, function(i, marker){
                    if(typeof marker !== 'undefined') {
                        marker.setMap(map);
                        bounds.extend(marker.position);
                    }
                })
            }else {
                $buttons.removeClass('is-active');
                $this.addClass('is-active');
                $.each(gmap_marker, function (i, marker) {
                    if(typeof marker !== 'undefined'){

                        if (parseInt(marker.type) === target) {
                            marker.setMap(map);
                            bounds.extend(marker.position);
                        } else {
                            marker.setMap(null);
                        }
                    }
                })
            }
            map.fitBounds(bounds);
           // gsap.to(window,{scrollTo:$('#map').offset().top - 70});
        });

    }


}
*/

function initMap(){
    const $buttons = $('.section-map--controls button');
    const $navCont = $('.map-buttons');

    const mapStyle = [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e8ded7"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#d9ccc3"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#92c7bf"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#d0ddf2"
                },
                {
                    "lightness": 17
                }
            ]
        }
    ];
    const $map = $('#map');

    if($map.length > 0) {

        const map_markers = mapData;

        if(typeof mapMain === 'undefined'){
            return false;
        }

        let main_cords = mapMain.split(',');

        const map =  new google.maps.Map($map[0], {
            center: new google.maps.LatLng(main_cords[0], main_cords[1]),
            zoom: 12,
            panControl: false,
            zoomControl: true,
            mapTypeControl: false,
            overviewMapControl: false,
            scaleControl: false,
            streetViewControl: false,
            scrollwheel: false,
            fullscreenControl: false,
            gestureHandling: 'cooperative',
            styles: mapStyle,
        });

        const gmap_marker = [];

        let prev_infowindow =false;

        let bounds = new google.maps.LatLngBounds();

        let main = new google.maps.Marker({
            position: new  google.maps.LatLng(main_cords[0], main_cords[1]),
            title: map_markers.main_marker_title,
            map: map,
            icon: {
                url: 'assets/svg/pin.svg',
                size: new google.maps.Size(147, 82),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(108, 82)
            },
            visible: true,
            zIndex: 100,
            main: true
        });

        google.maps.event.addListener(main, 'click', function () {
            if (prev_infowindow && typeof prev_infowindow !== 'undefined') {
                prev_infowindow.close();
            }
        });

        bounds.extend(main.position);

        $.each(map_markers, function (i, marker) {

            let icon = {
                url: 'assets/svg/point.svg',
                size: new google.maps.Size(43, 43),
                anchor: new google.maps.Point(21, 21),
                origin: new google.maps.Point(0, 0),
            };
            gmap_marker[i] = new google.maps.Marker({
                position: new google.maps.LatLng(marker.lat, marker.lng),
                title: marker.title,
                map: map,
                icon: icon,
                visible: true,
                zIndex: 70,
                main: false,
                type : marker.category
            });


            bounds.extend(gmap_marker[i].position);

            let walk = '';
            let car = '';
            //  let short = 'map-infowindow--short';
            if(marker.walk.length){
                //short = '';
                walk = '<div class="map-time"><div class="ico-walk"></div>' + marker.walk + '</div>'
            }
            if(marker.car.length){
                // short = '';
                car = '<div class="map-time"><div class="ico-car"></div>' + marker.car + '</div>'
            }
            let map_content = '<div class="map-infowindow " style="text-align: center">' +
                '<div class="map-title">' + marker.title + '</div>' + walk + car+ '</div>';

            let infoWindow = new SnazzyInfoWindow({
                marker: gmap_marker[i],
                content: map_content,
                placement: 'left',
                padding: '0px',
                border: false,
                offset: {
                    top: '-80px',
                    left: '36px'
                },
                showCloseButton: true,
                pointer: false,
                borderRadius: 'unset',
                wrapperClass: 'infoWindow',
                closeWhenOthersOpen: true,

            });
          //  infoWindow.open();

           /* let infowindow = new google.maps.InfoWindow({
                content: map_content
            });
*/


            google.maps.event.addListener(map, 'click', function () {


              /*  if (prev_infowindow && typeof prev_infowindow !== 'undefined') {
                    prev_infowindow.close();
                }*/
            });

            google.maps.event.addListener(gmap_marker[i], 'click', function () {
                infoWindow.open();
               /* if (prev_infowindow && typeof prev_infowindow !== 'undefined') {
                    prev_infowindow.close();
                }
                prev_infowindow = infowindow;

                if(! gmap_marker[i].main) {
                    infowindow.open(map, gmap_marker[i]);
                }*/
            });


        });

        map.fitBounds(bounds);

        $buttons.click(function(e){
            let $this = $(this);
            let target = $this.data('cat');

            bounds = new google.maps.LatLngBounds();
            bounds.extend(main.position);

            if(prev_infowindow && typeof prev_infowindow !== 'undefined') {
                prev_infowindow.close();
            }

            if($this.hasClass('is-active')){
                $this.removeClass('is-active');
                $.each(gmap_marker, function(i, marker){
                    if(typeof marker !== 'undefined') {
                        marker.setMap(map);
                        bounds.extend(marker.position);
                    }
                })
            }else {
                $buttons.removeClass('is-active');
                $this.addClass('is-active');
                $.each(gmap_marker, function (i, marker) {
                    if(typeof marker !== 'undefined'){

                        if (parseInt(marker.type) === target) {
                            marker.setMap(map);
                            bounds.extend(marker.position);
                        } else {
                            marker.setMap(null);
                        }
                    }
                })
            }
            map.fitBounds(bounds);
            // gsap.to(window,{scrollTo:$('#map').offset().top - 70});
        });

    }


}





function initApart(){
    const $filter = $('form.filter');
    const $filterFields = $filter.find('.filter-slider');
    const $loader = $('.filter-loader svg');
    const $table = $('.filter-list--table');
    const $reset = $('.filter-reset');


    if($filter.length){
        gsap.to($loader,{rotation: "+=360", repeat:-1, ease: 'Linear.easeNone', transformOrigin:"50% 50%" });
        let $sliders = $filterFields.ionRangeSlider({
            type: "double",
            skin: 'custom',
            grid: false,
            onFinish: function () {
               $filter.submit();
            },
        });
        $('.filter-reset button').click(function(e){
            e.preventDefault();
            $.each($filter.find('input'),function(){
                let slider = $(this).data("ionRangeSlider");
                slider.reset();
            });
            $filter.submit();
        });

        $filter.find('[type="checkbox"]').change(function(){
            $filter.submit();
        });
        has_filter($table);
    }

    $filter.submit(function(e){
        e.preventDefault();
        let $this = $(this);

        $.ajax({
            data: $this.serialize(),
            type: 'post',
            url: $this.attr('action'),
            beforeSend: function(){
                gsap.to($reset, { autoAlpha: 0});
                gsap.to($loader,{autoAlpha: 1});
            },
            success: function (data) {
            },
            complete: function(data){
            }
        }).done(function(data){

            gsap.to($loader,{autoAlpha: 0});
            data = JSON.parse(data);
            $table.html(' ');

            let url = window.location.href;
            url = url.split('?');

            window.history.replaceState('', '', url[0]+'?'+data.url);
            switch(data.status){
                case(0):
                    gsap.to($reset, { autoAlpha: 1});
                    break;
                case(1):
                    $table.html(data.html);
                    break;
            }

            ScrollTrigger.refresh();
            hookLineAnim();
        })

    });

    const $house = $('.svg-house svg a');
    const $houseTooltip = $('.house-tooltip');
    const $parking = $('.parking-icon');
    const $parkingTooltip = $('.parking-tooltip');
    const $garageTooltip = $('.garage-tooltip');
    const $floorNr = $houseTooltip.find('.house-tooltip--nr span');
    const $floorAmount = $houseTooltip.find('.tooltip--amount span');
    const $parkingAmount = '';

    $.each($house,function(e){
        let $this = $(this);
        if(typeof $this.attr('id') == 'undefined'){
            return false;
        }
        let floor = $this.attr('id').replace('floor_', '');

        $this.attr('href', moduleUlr +'/'+ floor + '-aukstas');

    });

    let reveal = gsap.timeline({paused:true, ease: "power2.out"});
    $.each($house,function(e) {
        let $this = $(this);
        if (typeof $this.attr('id') == 'undefined') {
            return false;
        }
        let path = $this.find('path');

        reveal.to(path, {fillOpacity: 0.8, duration: 1, onComplete: onComplete}, '-=0.89');

        function onComplete(){
            gsap.to(path,{delay: 0.4,fillOpacity: 0, duration:1})
        }
    });

    reveal.play();

    $house.mouseenter(function(){

        let $this = $(this);
        let id = $this.attr('id');
        let floor = id.replace('floor_','');

        if(floor != 0){
            $floorNr.html(floor);
            $floorAmount.html(floorData['floor'][floor]['available']);
        }
    }).mousemove(function(e){
        let $this = $(this);
        if($this.hasClass('parking-floor')){
            $houseTooltip.hide();
            $parkingTooltip.show();
            $garageTooltip.show();
            return false;
        }
        let left = e.clientX;
        let top = e.clientY;

        $houseTooltip.css('top',top - 4).css('left',left + 39).show();
    }).mouseleave(function(e){
        $houseTooltip.hide();
        $parkingTooltip.hide();
        $garageTooltip.hide();
    });


    function setParkingIcons() {
        $.each($parking, function (e) {
            let $this = $(this);
            let type = $this.data('type');
            let $point = null;
            let offset = null;
            switch (type) {
                case('parking'):
                    $point = $('g.parking');
                    offset = $point.offset();
                    $this.css({
                        'top': offset.top,
                        'left' : offset.left
                    });
                    $parkingTooltip.css({
                        'top': offset.top - 40,
                        'left': offset.left + 39
                    });
                    break;
                case('garage'):
                    $point = $('g.garage');
                    offset = $point.offset();
                    $this.css({
                        'top': offset.top,
                        'left' : offset.left
                    });
                    $garageTooltip.css({
                        'top': offset.top - 40,
                        'left' : offset.left + 39
                    });
                    break;
            }
        });
    }

    $parking.mouseenter(function(e){
        let $this = $(this);
        let type = $this.data('type');
        $houseTooltip.hide();
        $parkingTooltip.hide();
        $garageTooltip.hide();
        switch(type){
            case('parking'):
                $parkingTooltip.show();
                break;
            case('garage'):
                $garageTooltip.show();
                break;
        }



    });

    setParkingIcons();
    $(window).resize(function(e){
        setParkingIcons();
    });

    function triggerFloorAnim(){
        let floors = $(".svg-house svg a path");
        gsap.to(floors, {duration: 0.7, fillOpacity: 0.6, ease:"power1.in", stagger: {
            amount: 0.5,
            onComplete: function(){
                //console.log(this._targets[0]);
              //  console.log(this);
                console.log('clear');
                gsap.to(this, {delay: 0.1, duration: 1.25, fillOpacity: 0, ease:"power1.out", clearProps:"all"});
             /*   console.log(this._targets[0]);

               gsap.to(this._targets[0], {duration: 0.5, fillOpacity: 0, ease:"power1.out", clearProps:"all"});*/
            }
        }});
    }

    let $controls = $('.plan-controls button');
    $controls.click(function(e){
        e.preventDefault();
        let $this = $(this);
        if(!$this.hasClass('is-active')) {
            $controls.toggleClass('is-active');
            $('.apartment-plans a').toggleClass('is-active');
        }

    })
}

function floors(){
    const $svgCont = $('.svg-floor');
    //const $flats = $svgCont.find('');
    const $garage = $svgCont.find('.garage');
    const $floor = $('.svgfloor');
    if($svgCont.length === 0){
        return false;
    }
    const $tooltip = $('.floor-tooltip');

    if($garage.length){

        $.each(floorData,function(){
           $('#'+this.id).parent().addClass('garage-status--'+this.status);
        });

        let $marg = $svgCont[0].getBoundingClientRect();

        $('.tooltip-info').hide();
        $svgCont.mouseenter(function(){
            gsap.set($tooltip, {
                left: ($('#30-point')[0].getBoundingClientRect().left - $marg.left - $tooltip.width() / 2),
                top: ($('#30-point')[0].getBoundingClientRect().top - $marg.top - $tooltip.height() - 20),
                autoAlpha: 0,
                onComplete: function () {
                    gsap.set($tooltip,  {
                        //duration: 0.5,
                       // autoAlpha: 0,
                        onComplete: function () {
                            $tooltip.addClass('is-active');
                        }
                    });
                }
            });
        }).mouseleave(function(){
            $tooltip
                .removeClass('is-active')
                .removeClass('animating').css({opacity:0});
        });


        $garage.mouseenter(function(){
            $tooltip
                .removeClass('tooltip-status--Available')
                .removeClass('tooltip-status--Sold')
                .removeClass('tooltip-status--Reserved');
            
            let $this = $(this);
            let $spot = $('#'+$this.attr('id')+'-point');
            let $status = $tooltip.find('.tooltip-status');
            $marg = $svgCont[0].getBoundingClientRect();
            $.each(floorData,function(){
               if(this.id == $this.attr('id')){
                    $('.tooltip-nr').html(this.nr);

                    console.log(this.id);
                   $tooltip.addClass('tooltip-status--'+this.status);
                   if(this.status == 'Sold'){
                       $status.html('Parduotas');
                   }
                   if(this.status == 'Reserved'){
                       $status.html('Rezervuotas');
                   }
                   if(this.status == 'Available'){
                       $status.html('Laisvas');
                   }
                   if(typeof this.price === 'undefined'){
                       this.price = 0;
                       this.disc = 0;
                   }

                   if(parseInt(this.price) == 0){
                       $('.tooltip-disc').hide();
                       $('.tooltip-price').hide();
                       $('.tooltip-prices').removeClass('tooltip-discounted');
                       $tooltip.addClass('no-prices');

                   }else{
                       if(parseInt(this.disc) !== 0 ){
                           $('.tooltip-disc').html(this.disc + ' €').show();
                           $('.tooltip-prices').addClass('tooltip-discounted');
                       }else{
                           $('.tooltip-prices').removeClass('tooltip-discounted');
                           $('.tooltip-disc').html(this.disc + ' €').hide();
                       }
                       $tooltip.removeClass('no-prices');

                       $('.tooltip-price').html(this.price + ' €').show();
                   }
                   let $extra = $tooltip.find('.tooltip-extra');
                   if(this.id == 26) {
                       $extra.html('+Sandėliukas 5,75m<sup>2</sup>').show();
                       $tooltip.removeClass('no-prices');
                   }else if(this.id == 55 ){
                       $extra.html(' Sandėliukas 6,80 m<sup>2</sup>').show();
                       $tooltip.removeClass('no-prices');
                   }else{
                       $extra.hide();
                   }
               }
            });

            if (!$tooltip.hasClass('is-active')) {
                $tooltip.addClass('animating');
                gsap.set($tooltip, {
                    left: ($spot[0].getBoundingClientRect().left - $marg.left - $tooltip.width() / 1.4),
                    top: ($spot[0].getBoundingClientRect().top - $marg.top - $tooltip.height() - 20 ),
                    autoAlpha:1,
                    onComplete: function () {
                        gsap.to($tooltip,  {
                            duration: 0.5,
                            autoAlpha: 1,
                            onComplete: function () {
                                $tooltip.addClass('is-active');
                            }
                        });
                    }
                });
            } else {
                gsap.to($tooltip, {
                    duration: 0.5,
                    autoAlpha: 1,
                    left: ($spot[0].getBoundingClientRect().left - $marg.left - $tooltip.width() / 1.4),
                    top: ($spot[0].getBoundingClientRect().top - $marg.top - $tooltip.height()  - 20),
                    force3D: true
                });
            }
        }).mouseleave(function(){
            $tooltip.removeClass('animating')
        })

    }

    if($floor.length){
        $.each(floorData,function(){
            $('#'+this.id).parent().attr('href',floorUlr+'/'+this.nr).addClass('apart-status--'+this.status);
        });

        $('.apart').mouseenter(function (e) {
            $tooltip.removeClass('tooltip-status--Available').removeClass('tooltip-status--Sold').removeClass('tooltip-status--Reserved');
            let $this = $(this);
            let $spot = $('#'+$this.attr('id')+'-point');
            let $status = $tooltip.find('.tooltip-status');
            let $marg =  $svgCont[0].getBoundingClientRect();


            $.each(floorData,function(){
                if(this.id == $this.attr('id')){
                    $('.tooltip-nr').html(this.nr);
                    $tooltip.addClass('tooltip-status--'+this.status);
                    if(this.status == 'Sold'){
                        $status.html('Parduotas');
                    }
                    if(this.status == 'Reserved'){
                        $status.html('Rezervuotas');
                    }
                    if(this.status == 'Available'){
                        $status.html('Laisvas');
                    }

                    $('.tooltip-area span').html(this.area);
                    $('.tooltip-room span').html(this.rooms);

                    if(typeof this.price === 'undefined'){
                        this.price = 0;
                        this.disc = 0;
                    }

                    if(parseInt(this.price) == 0){
                        $('.tooltip-disc').hide();
                        $('.tooltip-price').hide();
                        $('.tooltip-prices').removeClass('tooltip-discounted');
                        $tooltip.addClass('no-prices');

                    }else{
                        if(parseInt(this.disc) !== 0 ){
                            $('.tooltip-disc').html(this.disc + ' €').show();
                            $('.tooltip-prices').addClass('tooltip-discounted');
                        }else{
                            $('.tooltip-prices').removeClass('tooltip-discounted');
                            $('.tooltip-disc').html(this.disc + ' €').hide();
                        }
                        $tooltip.removeClass('no-prices');
                        $('.tooltip-price').html(this.price + ' €').show();
                    }
                }
            });


            if (!$tooltip.hasClass('is-active')) {
                $tooltip.addClass('animating');
                gsap.set($tooltip, {
                    left: ($spot[0].getBoundingClientRect().left - $marg.left - $tooltip.width() / 1.4),
                    top: ($spot[0].getBoundingClientRect().top - $marg.top - $tooltip.height()  - 20),
                    onComplete: function () {
                        gsap.to($tooltip, {
                            duration:0.5,
                            autoAlpha: 1,
                            onComplete: function () {
                                $tooltip.addClass('is-active');
                            }
                        });
                    }
                });

            } else {
                gsap.to($tooltip, {
                    duration: 0.5,
                    left: ($spot[0].getBoundingClientRect().left - $marg.left - $tooltip.width() / 1.4),
                    top: ($spot[0].getBoundingClientRect().top - $marg.top - $tooltip.height()  - 20),
                    force3D: true
                });
            }

        });
        $floor.mouseleave(function (e) {
            $tooltip.removeClass('animating').removeClass('is-active');
            gsap.to($tooltip, 0.2, {autoAlpha: 0});
        });
    }

    $(document).on('click', '.apart-status--Sold', function(e){
        e.preventDefault();
    })


}
var hookedLines = [];
var hookLineAnim = function(){
    hookedLines.forEach(function(e){
        e.kill();
    });
    hookedLines = [];
    let rows = $(".anim-rows");
    for(let i=0; i<rows.length; i++){
        let st = ScrollTrigger.create({
            trigger: rows.eq(i),
            start: "top bottom",
            toggleClass: "anim-trigger",
            //markers:true
        });
        hookedLines.push(st);
    }
    //rows.css("opacity",1);
}

function txtanm() {
    let telem = $(".title-anim");
    let title = new SplitText(".title-anim", {type:"words,chars", charsClass:"s-chr"});
    let tls = [];
    for(let i=0; i<telem.length; i++){
        let tl= gsap.timeline({
            paused: true,
            scrollTrigger: {
                trigger: telem.eq(i),
                toggleActions: "play complete none reverse",
                start: "top 85%",
                //markers: true
            }
        });
        tl.fromTo(telem.eq(i).find('.s-chr'), {opacity:0, scale:0.2}, {duration:0.6, opacity:1, scale:1, transformOrigin:"left top", force3D:true, stagger:{each:0.03}, ease:"power2.out"});
    }
    telem.css("opacity",1);

    let fadeupelem = $(".anim-fade-up");
    for(let i=0; i<fadeupelem.length; i++){
        ScrollTrigger.create({
            trigger: fadeupelem.eq(i),
            start: "top+=50% bottom",
            toggleClass: "anim-trigger",
            //markers:true
        });
    }
}

txtanm();
$(function(){
    hookLineAnim();
});
$(function(){
    let svgs = $(".svg-anim-group");
    for(let i=0; i<svgs.length; i++){
        let tl= gsap.timeline({
            paused: true,
            scrollTrigger: {
                trigger: svgs.eq(i),
                toggleActions: "play pause resume none",
                start: "top+=50% bottom",
                //markers: true
            }
        });
        tl.fromTo(svgs.eq(i).find('path'), {drawSVG:"50% 50%", opacity:0}, {duration:3, drawSVG:"0% 100%", opacity:1,stagger:{each:0.05}, ease:"power2.out"});
    }
    svgs.css("opacity",1);
});

$(document).ready(function(){
    slides.init();
    scrollTo.init();
    initMap();
    formFields();
    initApart();
    floors();
    initBrokers();

    $('.btn-menu').click(function(e){
        e.preventDefault();
        $('.main-menu').toggleClass('is-active');
    });

    $(document).scroll(function(){
        if($(document).scrollTop() > 1){
            $('.bt-scrollUp').css({
                opacity: 1,
                pointerEvents: 'auto'
            });
            $('header').addClass('header-sticky');
        }else{
            $('.bt-scrollUp').css({
                opacity: 0,
                pointerEvents: 'none'
            });
            $('header').removeClass('header-sticky');
        }
    });

    if($(document).scrollTop() > 1){
        $('.bt-scrollUp').css({
            opacity: 1,
            pointerEvents: 'auto'
        });
        $('header').addClass('header-sticky');
    }

    function setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let $cf = $('#footer-cookie');
    let cfa = 'footer-cookie--active';

    if(getCookie('cookie-policy') == '1'){
        $cf.removeClass(cfa);
    } else {
        $cf.addClass(cfa);
    }

    $('.cookie-accept').click(function(e){
        e.preventDefault();
        setCookie('cookie-policy', '1', 365);
        $cf.removeClass(cfa);
    });

    if(typeof popuptime !== 'undefined') {

        var offerspopupShow = 1;

        var offerspopuptimer = setTimeout(function () {
                $.fancybox.open({
                    src: '#popup-offers',
                    type: 'inline',
                    baseClass: 'popup',
                    touch: false,
                    afterShow: function (instance) {
                        instance.current.$content.find('.anim-fade-up').addClass('anim-trigger');
                        document.cookie = "popup-offers=1;expires=0;path=/";
                        offerspopupShow = 0;
                    }
                });
            }, popuptime
        );

        if (showLeave == 1) {
            $(document).mouseleave(function(){

                if ($('.fancybox-container.popup').length == 0 && offerspopupShow) {
                    $.fancybox.open({
                        src: '#popup-offers',
                        type: 'inline',
                        baseClass: 'popup',
                        touch: false,
                        afterShow: function (instance) {
                            instance.current.$content.find('.anim-fade-up').addClass('anim-trigger');
                            document.cookie = "popup-offers=1;expires=0;path=/";
                            offerspopupShow = 0;
                        }
                    });
                    clearInterval(offerspopuptimer);
                }
            })
        }
    }



    const $page = $('#page-load');
    if($page.length){
        gsap.to($page,{autoAlpha:0,duration: 1, delay:0.15, onComplete: function(){
            $page.remove();
        }})
    }

    $(document).on('click','.list-sold a', function(e){
        e.preventDefault();
    })

    $(document).on('click','#floor-place a',function(e){
        e.preventDefault();
    })


    var projectslistpopup = $('.projects-list-popup');

    if(projectslistpopup.length) {
        var projectslistpopuptimer = setInterval(function () {
            projectslistpopup.addClass('active');
            $(document).off('mouseleave.popupproject');
        }, popup_show_time);
    }

    projectslistpopup.find('.close-popup').click(function(e){
        e.preventDefault();
        $(this).parent().removeClass('active');
        clearInterval(projectslistpopuptimer);
    });

    $(document).on('mouseleave.popupproject', function () {
        projectslistpopup.addClass('active');
        clearInterval(projectslistpopuptimer);
        $(document).off('mouseleave.popupproject');
    });

});